import axios from "axios";

const asaasGeneratePaymentSlip = async ({
  asaasCustomerId,
  value,
  description,
  type,
  uuid,
}) => {
  try {
    const { data } = await axios.post(
      `/asaas/payment/slip`,
      {
        asaasCustomerId,
        value,
        description,
        type,
        uuid,
      }
    );

    if (!data?.success) throw new Error();

    return {
      success: true,
      message: "Sucesso ao gerar pagamento",
      paymentId: data?.paymentId,
      bankSlipUrl: data?.bankSlipUrl,
    };
  } catch (error) {
    return {
      success: false,
      message: "Erro ao gerar pagamento",
    };
  }
};

export { asaasGeneratePaymentSlip };
